import { Pipe, PipeTransform } from '@angular/core';
import { PRESSURE_UNITS } from '../lib/units';
@Pipe({ name: 'pressure' })
export class PressurePipe implements PipeTransform {
  public transform(pressure: number, useMetricUnits: boolean, currentDataUnits: string): number {
    if (!useMetricUnits && currentDataUnits === PRESSURE_UNITS.KILO_PASCAL) {
      return pressure / 6.895;
    } else if (useMetricUnits && currentDataUnits === PRESSURE_UNITS.POUNDS_PER_SQUARE_INCH) {
      return pressure * 6.895;
    } else if (currentDataUnits !== PRESSURE_UNITS.KILO_PASCAL && currentDataUnits !== PRESSURE_UNITS.POUNDS_PER_SQUARE_INCH) {
      console.warn('Detected a pressure conversion argument which is not supported, returning result as it was passed');
    }
    return pressure;
  }
}
